<template>
  <mp-box my="10" mx="5" text-align="center">
    <img :src="image" alt="icon-blankslate" class="mx-auto" :width="isSmall ? '170' : '288'" />
    <mp-box font-weight="semibold" :font-size="isSmall ? '' : 'lg'">{{ blankSlateData.title }}</mp-box>
    <mp-box v-if="!hideSubtitle" max-w="376px" mx="auto" mt="1" color="gray.600">{{ blankSlateData.sub_title }}</mp-box>

    <slot />

    <router-link v-if="blankSlateData.link" :to="blankSlateData.link">
      <mp-button mt="5" :size="isSmall ? 'sm' : 'md'">{{ blankSlateData.btn_text }}</mp-button>
    </router-link>
  </mp-box>
</template>
<script>
export default {
  name: 'BlankSlate',
  props: {
    isSmall: {
      type: Boolean,
      default: false,
    },
    blankSlateData: {
      type: Object,
      default: () => {
        return {
          title: 'No Data',
          sub_title: 'You need to add some data for it to work',
          img: this.$store.state.assets.defaultBlankImg,
        };
      },
    },
    hideSubtitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      image: null,
    };
  },
  mounted() {
    this.image = this.blankSlateData.img || this.$store.state.assets.defaultBlankImg;
  },
};
</script>
